import React, { Component } from 'react';

// import components
import MapTab from './MapTab';
import DescriptionTab from './DescriptionTab';
import FlatList from './FlatList';
import KeyFeaturesTab from './KeyFeaturesTab';
import AreaInfo from './AreaInfo';

class PropertyInfo extends Component {
  render() {
    const { property, loading } = this.props;
    return (
      <div className="property-info">
        {/* Tab header items */}
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item">
            <a
              className="nav-link active"
              id="description-tab"
              data-toggle="tab"
              href="#description"
              role="tab"
              aria-controls="description"
              aria-selected="true"
            >
              Description
            </a>
          </li>
          <li className="nav-item">
            <a
              className="nav-link"
              id="rooms-tab"
              data-toggle="tab"
              href="#rooms"
              role="tab"
              aria-controls="rooms"
              aria-selected="true"
            >
              Rooms
            </a>
          </li>
          <li className="nav-item">
            <a
              className="nav-link"
              id="features-tab"
              data-toggle="tab"
              href="#features"
              role="tab"
              aria-controls="features"
              aria-selected="true"
            >
              Features
            </a>
          </li>
          <li className="nav-item">
            <a
              className="nav-link"
              id="inTheArea-tab"
              data-toggle="tab"
              href="#inTheArea"
              role="tab"
              aria-controls="inTheArea"
              aria-selected="true"
            >
              In the area
            </a>
          </li>
          <li className="nav-item">
            <a
              className="nav-link"
              id="map-tab"
              data-toggle="tab"
              href="#map"
              role="tab"
              aria-controls="map"
              aria-selected="false"
            >
              Map
            </a>
          </li>
        </ul>

        {/* Tab components */}
        <div className="tab-content" id="myTabContent">
          <DescriptionTab property={property} loading={loading} />
          <FlatList />
          {property.area && <AreaInfo area={property.area} />}
          <KeyFeaturesTab property={property} loading={loading} />
          <MapTab property={property} loading={loading} />
        </div>
      </div>
    );
  }
}

export default PropertyInfo;
